import React from "react"
import { Linking, View } from "react-native"
import { Ionicons } from "@expo/vector-icons"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { BodyBold, H5 } from "@/components/standard/BFText"
import { Button } from "@/components/reusables/ui/button"
import { accessAllWebinarsClicked } from "@/analytics/events/communityEvents"

interface EventsFooterProps {
  onBrowseWebinars?: () => void
}

/**
 * Footer component for "Looking for more?" section
 */
const EventsFooter: React.FC<EventsFooterProps> = ({
  onBrowseWebinars = async () => {
    accessAllWebinarsClicked()
    await Linking.openURL(
      "https://www.youtube.com/playlist?list=PLYFkuf_Px0VcTNHzPQuAiFlxMfjOM9vMr"
    )
  },
}) => {
  return (
    <View className="py-5 w-full">
      <Vertical className="items-center gap-1 px-5">
        <H5 className="text-center text-midnight-blue py-12">
          Looking for more?
        </H5>
        <Button variant={"link"} className="mt-3" onPress={onBrowseWebinars}>
          <Horizontal className="items-center gap-2">
            <Ionicons name="logo-youtube" size={18} color="#286588" />
            <BodyBold className="text-calm-blue">Browse webinars</BodyBold>
          </Horizontal>
        </Button>
      </Vertical>
    </View>
  )
}

export default EventsFooter
